/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useMemo, useState } from 'react';

import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import useMouseEvents from '../../../../../../hooks/useMouseEvents';
import { useLoader, useThree } from '@react-three/fiber';
import { NormalStripeImg } from '../../../../../../utils/Textures';
import { LapSiding } from '../../../../../../utils/Textures';
import { boardBatten } from '../../../../../../utils/Textures';
import { LapMap } from '../../../../../../utils/Textures';
import { controls } from '../../../../../../redux/reducers/eventReducer';

const OutsideWallModel = () => {
    const [wallCloseState, setWallCloseState] = useState(0);
    
    const canvasElement = document.getElementsByClassName("building-size")
    const isPattern = (canvasElement != undefined && canvasElement[0] && canvasElement[0].clientWidth > 1050 && !params.p_v_w) ? true : false
    const wainscotColor = useMemo(() => (params.p_w_c_c.replace("0x","#")), [params.p_w_c_c])
    const { gl } = useThree();
    // const texture = useLoader(THREE.TextureLoader,  process.env.REACT_APP_BASE_URL+NormalStripeImg);

    // let map = LapSiding //NormalStripeImg
    // // let texture = useLoader(THREE.TextureLoader,  process.env.REACT_APP_BASE_URL+map);
    // switch(params.wallTexture){
    //     case "lap" :
    //         map = LapSiding
    //     break;
    //     case "board_batten" :
    //         map = boardBatten
    //     break;
    //     case "vertical" :
    //         map = NormalStripeImg
    //     break;
    //     default:
    //         map = NormalStripeImg
    // }
    // let texture = useLoader(THREE.TextureLoader,  process.env.REACT_APP_BASE_URL+map);
    // const lapMap = useLoader(THREE.TextureLoader,  process.env.REACT_APP_BASE_URL+LapMap);

    const gableCutModel = useMemo(() => {
        let leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) :  params.p_h
        let rightStorageHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - (parseInt(params.cB_addStorage_right) * params.p_r_p / 12) : (parseInt(params.cB_addStorage_right) > params.p_w / 2) ? ((params.p_w - parseInt(params.cB_addStorage_right)) * (params.p_r_p/12)) + params.p_h + (params.p_r_s === 1 ? 0.37 : 0):  (parseInt(params.cB_addStorage_right) * (params.p_r_p/12)) + params.p_h + (params.p_r_s === 1 ? 0.37 : 0);
        let leftStorageHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_w - parseInt(params.cB_addStorage_left)) * params.p_r_p / 12) : (parseInt(params.cB_addStorage_left) > params.p_w / 2) ? ((params.p_w - parseInt(params.cB_addStorage_left)) * (params.p_r_p/12)) + params.p_h + (params.p_r_s === 1 ? 0.37 : 0) :  (parseInt(params.cB_addStorage_left) * (params.p_r_p/12)) + params.p_h + (params.p_r_s === 1 ? 0.37 : 0);
        let wallState = (wallCloseState > -1) ? wallCloseState : 0;
        
        const model = new THREE.Shape();
        if(wallCloseState > -1 || params.cB_addStorage_check_left ) model.moveTo(-(params.p_w / 2), leftHeight );
        if((!params.singleSlope) && (params.cB_addStorage_check_right && params.p_f_w === "Open")){
            model.moveTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), rightStorageHeight);
        }
        if(params.p_r_s == 1 && (wallCloseState > -1 || params.cB_addStorage_check_left)){
            model.lineTo(-(params.p_w / 2) + 0.01, params.p_h );
            model.lineTo(-(params.p_w / 2) + 0.01, params.p_h + 0.3);
            model.lineTo(-(params.p_w / 2) + 0.03, params.p_h + 0.33);
            model.lineTo(-(params.p_w / 2) + 0.06, params.p_h + 0.37);
            model.lineTo(-(params.p_w / 2) + 0.1, params.p_h + 0.39);
            if((wallCloseState > -1) || (params.cB_addStorage_check_right && parseInt(params.cB_addStorage_right) >= params.p_w / 2) || (parseInt(params.cB_addStorage_left) >= params.p_w / 2)) model.lineTo(0, params.p_h + ((params.p_r_p / 12) * (params.p_w/2)) + 0.37);
        }else{
            if(((wallCloseState > -1) || (params.cB_addStorage_check_right && parseInt(params.cB_addStorage_right) >= params.p_w / 2) || (parseInt(params.cB_addStorage_left) >= params.p_w / 2)) && (!params.singleSlope)) model.lineTo(0, params.p_h + ((params.p_r_p / 12) * (params.p_w/2)) + (params.p_r_s === 1 ? 0.37 : 0) );
        }
        if(!params.singleSlope && (params.cB_addStorage_check_left && params.p_f_w === "Open")) model.lineTo(params.p_w / -2 + parseInt(params.cB_addStorage_left), leftStorageHeight );

        if(params.p_r_s == 1  && (wallCloseState > -1 || params.cB_addStorage_check_right)){
            model.lineTo((params.p_w / 2) - 0.1, params.p_h + 0.39);
            model.lineTo((params.p_w / 2) - 0.06, params.p_h + 0.37);
            model.lineTo((params.p_w / 2) - 0.03, params.p_h + 0.33);
            model.lineTo((params.p_w / 2) - 0.01, params.p_h + 0.3);
            model.lineTo((params.p_w / 2) - 0.01, params.p_h );

        }

        if(wallCloseState > -1 || (params.cB_addStorage_check_right && params.p_f_w !== 'Open')) model.lineTo((params.p_w / 2), params.p_h);
        if(wallCloseState > -1 || (params.cB_addStorage_check_right && params.p_f_w === 'Open')) model.moveTo((params.p_w / 2), params.p_h);
        if(wallCloseState > -1 || params.cB_addStorage_check_right) model.lineTo((params.p_w / 2),  wallState); // center building right bottom
        if(params.p_f_w !== 'Open' && params.cB_addStorage_check_right){
            model.lineTo(params.p_w / 2, 0 );
            model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), 0 );
            model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), wallState );
        }
        if(params.p_f_w === 'Open' && params.cB_addStorage_check_right){
            model.lineTo(params.p_w / 2, 0 );
            model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), 0 );
            model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), rightStorageHeight );      
        }
        if(params.p_f_w !== 'Open' && params.cB_addStorage_check_left){
            model.lineTo(params.p_w / -2 + parseInt(params.cB_addStorage_left), wallState );
            model.lineTo(params.p_w / -2 + parseInt(params.cB_addStorage_left), 0 );
            model.lineTo(params.p_w / -2, 0 );
        }
        if(params.p_f_w === 'Open' && params.cB_addStorage_check_left){
            model.lineTo(params.p_w / -2 + parseInt(params.cB_addStorage_left), leftStorageHeight );
            model.lineTo(params.p_w / -2 + parseInt(params.cB_addStorage_left), 0 );
            model.lineTo(params.p_w / -2, 0 );
        }
        if(wallCloseState > -1 || params.cB_addStorage_check_left) model.lineTo(-(params.p_w / 2), wallState); // center building left bottom
        if(wallCloseState > -1) model.closePath();
        return model;
    
    }, [params.p_h, params.p_w, params.cB_addStorage_check_left,params.cB_addStorage_check_right, params.cB_addStorage_left,params.cB_addStorage_right, params.p_f_w, params.p_r_p, params.p_r_s,wallCloseState, params.freeStandingSide, params.singleSlope])

    const dutchDelModel = useMemo(() => {
        const freeSpace = 1;
        const cornerFreeSpaceW = freeSpace * 2;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) :  params.p_h
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = cornerFreeSpaceW;
        
        if (!params.cB_addStorage_check_left && !params.cB_addStorage_check_right && (params.p_f_w === "Half Dutch End" || params.p_f_w === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.p_w / 2 - freeSpace), 0);

            if (params.p_f_w === "Half Dutch End") {
                model.lineTo(-(params.p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
            } else {
                model.lineTo(-(params.p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), leftHeight - freeSpace);
            }
            model.lineTo((params.p_w / 2 - freeSpace), 0);

            return model;
        } else {
            return []
        }
    }, [params.p_w, params.p_h, params.p_f_w, params.cB_addStorage_check_left, params.cB_addStorage_check_right])

    const mainWallModel = useMemo(() => {
        const regularHeight = (params.p_r_s == 1) ? 0.4 : 0
        /************** cutting hole using CSG ***************/
        const verticalHorizontalPos = params.p_v_w == true ? {"x":params.p_w / 2,"y": ((params.p_w_c_n && (params.p_f_w === 'Close' || params.cB_addStorage_check_left || params.cB_addStorage_check_right)) ? 2.935 : 0), "z":params.p_d / 2 + 0.16} : {"x": params.p_w / -2,"y" :((params.p_w_c_n && (params.p_f_w === 'Close' || params.cB_addStorage_check_left || params.cB_addStorage_check_right)) ? 2.935 : 0), "z" : params.p_d / 2 + 0.16}
        const verticalHorizontalRot = params.p_v_w == true ? {"x":Math.PI / 2,"y" : Math.PI,"z" : 0} : {"x":0,"y" : Math.PI / 2,"z" : Math.PI / 2}
        const patternLength = params.p_v_w == true ? params.p_w : params.p_h + ((params.p_r_p / 12) * (params.p_w/2)) + regularHeight + ((params.p_w_c_n && (params.p_f_w === 'Close' || params.cB_addStorage_check_left || params.cB_addStorage_check_right)) ? -2.935 : 0)
        const patternDepth = params.p_v_w == true ? params.p_h + ((params.p_r_p / 12) * (params.p_w/2)) + regularHeight + ((params.p_w_c_n && (params.p_f_w === 'Close' || params.cB_addStorage_check_left || params.cB_addStorage_check_right)) ? -2.935 : 0) : params.p_w
    
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength,isPattern), extrudeSettings(patternDepth)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('front', 'wall'), extrudeSettings(1)))    
        const meshGableDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(gableCutModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))
        
        let meshWallModel_Temp = meshWallModel.clone();
        meshWallModel_Temp.position.set(verticalHorizontalPos.x,verticalHorizontalPos.y,verticalHorizontalPos.z);
        meshWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshWallModel_Temp.updateMatrixWorld();
    
        let meshGableDelModel_Temp = meshGableDelModel.clone();
        meshGableDelModel_Temp.position.set(0,0,params.p_d / 2 - 0.5);
        meshGableDelModel_Temp.updateMatrixWorld();
    
        // mesh to cut the gable
        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(0, 0, params.p_d / 2 - 0.5);
        meshDelModel_Temp.updateMatrixWorld();
    
        // mesh to cut the dutch model
        let meshDutchDelModel_Temp = meshDutchDelModel.clone();
        meshDutchDelModel_Temp.position.set(0,0,params.p_d / 2 - 0.5);
        meshDutchDelModel_Temp.updateMatrixWorld();
    
        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshGableDelModel_CSG = CSG.fromMesh(meshGableDelModel_Temp);
        const meshDutchDelModel_CSG = CSG.fromMesh(meshDutchDelModel_Temp);
    
        const wallModel_CSG = meshWallModel_CSG.subtract(meshDelModel_CSG);
        const gableModel_CSG = wallModel_CSG.intersect(meshGableDelModel_CSG);
        const FrontWallModel_CSG = gableModel_CSG.subtract(meshDutchDelModel_CSG);
    
        const CSGWallModel = CSG.toMesh(FrontWallModel_CSG, new THREE.Matrix4())
    
        /************** cutting hole in wainscot using CSG ***************/
        const wainscotVerticalHorizontalPos = params.p_v_w == true ? {"x":params.p_w / 2,"y": 0, "z":params.p_d / 2 + 0.16} : {"x": params.p_w / -2,"y" :0, "z" : params.p_d / 2 + 0.16}
        const wainscotVerticalHorizontalRot = params.p_v_w == true ? {"x":Math.PI / 2,"y" : Math.PI,"z" : 0} : {"x":0,"y" : Math.PI / 2,"z" : Math.PI / 2}
        let lengthPattern = (params.p_v_w) ? patternLength : 3
        let depthPattern = (params.p_v_w) ? 3 : patternDepth
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPattern,isPattern), extrudeSettings(depthPattern)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(wainscotVerticalHorizontalPos.x,wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z);
        meshWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);
        let meshDutchDelModel_TempS = meshDutchDelModel.clone();
        meshDutchDelModel_TempS.position.set(0,0,verticalHorizontalPos.z - 0.5);
        meshDutchDelModel_TempS.updateMatrixWorld();
    
        const meshDutchDelModel_CSGS = CSG.fromMesh(meshDutchDelModel_TempS);
    
        const wainscotModel_CSG = meshWainscotModel_CSG.subtract(meshDutchDelModel_TempS);
        const frontWainscotModel_CSG = wainscotModel_CSG.subtract(meshDutchDelModel_CSGS);
        const frontWainscotModelCSG = frontWainscotModel_CSG.subtract(meshDelModel_CSG);
        const wainscotModelCSG = frontWainscotModelCSG.intersect(meshGableDelModel_CSG);
        const CSGWainscotModel = CSG.toMesh(
            wainscotModelCSG,
            new THREE.Matrix4()
        )

        // setCSGWallModelGeometry(CSGWallModel.geometry);
        // setCSGWainscotModelGeometry(CSGWainscotModel.geometry);

        return {
            wall: CSGWallModel.geometry,
            wainScot: CSGWainscotModel.geometry
        }
    
        /****************************************** *********/

    }, [params.wallTexture,params.wallTexture,params.p_h, params.p_d, params.p_w, params.p_v_w, params.cB_addStorage_check_left,params.cB_addStorage_check_right, params.cB_addStorage_left,params.cB_addStorage_right, params.p_f_w, params.p_r_p, params.p_r_s,wallCloseState, const_var.newDoorsArray, params.p_w_c_n]);

    useMemo(() => {
        let wallCloseValue = -1;
        let leanHeightValue = -1;
        let leftHeight = params.p_h;

        if (params.singleSlope && params.freeStandingSide === "left") leftHeight = params.p_h - ((params.p_r_p / 12) * params.p_w)
        else leftHeight = params.p_h;
        
        if (params.p_f_w === 'Open') {
            wallCloseValue = -1;
        } else if (params.p_f_w === "Gable") {
            wallCloseValue = leftHeight - 0.2;
        } else if (params.p_f_w === "Extended Gable") {
            wallCloseValue = leftHeight - 3;
        } else if (params.p_f_w === "One_Fourth_Close") {
            wallCloseValue = (leftHeight * 3) / 4;
        } else if (params.p_f_w === "Half_Close") {
            wallCloseValue = leftHeight / 2;
        } else if (params.p_f_w === "Three_Fourth_Close") {
            wallCloseValue = leftHeight / 4;
        } else if (params.p_f_w === "Close" || params.p_f_w === "Half Dutch End" || params.p_f_w === "Half End") {
            wallCloseValue = 0;
        }

        // if(params.p_w_c_n === true && params.p_f_w === "Close") wallCloseValue = 3

        if (params.add_front_lean) {
            let leanFinalHeight = params.p_h - (params.leanF_p_h + (parseInt(params.b_l_t_r_pF)/12) * params.leanF_p_w);
            if(params.add_front_lean ==true && Object.values(const_var.wallArray["front"])[0] == params.p_f_w || params.add_front_lean ==true && params.p_f_w == "Open")
            {    
              params.p_f_w = params.p_f_wF
              let wH = leanFinalHeight+0.2;
              setWallCloseState(params.p_h - wH);

            }else{
                setWallCloseState(wallCloseValue);
            }
        } else {
            setWallCloseState(wallCloseValue);
        }
    
    }, [params.singleSlope, params.freeStandingSide, params.p_r_p, params.p_w, params.p_h, params.p_f_w, params.add_front_lean, params.leanF_p_h, params.b_l_t_r_pF, params.leanF_p_w,params.p_w_c_n, params.cB_addStorage_check_left, params.cB_addStorage_check_right,JSON.stringify(const_var.wallArray)])

    const mainColor = useMemo(() => params.p_w_c.replace('0x', '#'), [params.p_w_c]);
    
    const handleMouseEvent = (e) => {
        if (params.activeWall !== "c_b_f_s_w") {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

    const texture = useMemo(() => {
        let texture = const_var.wallTextureObj[params.wallTexture];
        textureAnisotropy(gl, texture,(params.wallTexture == "board_batten")? 0.7 : 1.3, (params.wallTexture == "lap")? 0.5 : 1.3, Math.PI/-2);    
        return texture
    }, [params.p_v_w,params.wallTexture])

    return (
        <group {...eventHandlers}>
            {(params.p_f_w !== 'Open' || params.cB_addStorage_check_left || params.cB_addStorage_check_right) && mainWallModel?.wall &&
                <mesh name="c_b_f_w" geometry={mainWallModel?.wall} >
                    <meshStandardMaterial aoMap={texture} aoMapIntensity={(params.p_v_w || !isPattern) ? 0.6 : (params.wallTexture == "board_batten") ? 1 :  (params.wallTexture == "lap")? 0.6 : 0}  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={(params.p_v_w || params.wallTexture != "none") ? 0 : 0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} needsUpdate={true}/>
                </mesh>
            }

            {params.p_w_c_n === true && ((params.p_f_w === "Close" || params.p_f_w === "Half Dutch End" || params.p_f_w === "Half End") || (params.cB_addStorage_check_left) || (params.cB_addStorage_check_right)) && mainWallModel?.wainScot &&
                <mesh name="c_b_f_w_wainscot" geometry={mainWallModel?.wainScot} position={[0, 0, 0.005]}>
                    <meshStandardMaterial aoMap={texture} aoMapIntensity={(params.p_v_w || !isPattern) ? 0.6 : (params.wallTexture == "board_batten") ? 1 :  (params.wallTexture == "lap")? 0.6 : 0}  color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={(params.p_v_w || params.wallTexture != "none") ? 0 : 0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} needsUpdate={true}/>
                </mesh>
            }
        </group>
    )
}

export default OutsideWallModel